/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable @typescript-eslint/naming-convention */
import { CircularProgress, Portal } from "@material-ui/core";
import RoundedCloseIcon from "assets/svgs/RoundedCloseIcon";
import WarningIcon20 from "assets/svgs/WarningIcon20";
import clsx from "clsx";
import Button from "components/Buttons/Button";
import useMediaQuery from "hooks/useMediaQuery";
import { trackOnMixpanel } from "modules/candidate/profile/utils/MixpanelHelper";
import Image from "next/image";
import { WEB_JOB_APPLICATION_INELIGIBLE_SCREEN_SHOWN } from "modules/jobDetails/constants/mixpanelConstants";
import { useEffect } from "react";
import styled, { css } from "styled-components";
import { bp, getGlobalCSSVariants } from "theme";
import CrossIcon from "components/RevampFeedDetails/assets/CrossIcon";

const InEligibleJobNudge = ({
	isCTACardOpen,
	handleCloseClick,
	requirementsData,
	handlePrimaryBtnClick,
	handleSecondaryBtnClick,
	handleSecondaryBtnLoading,
	handleSecondaryBtnDisabled,
	commonTrackEventsJobProperties,
	jobRequirementsMPData,
	dealBreakerScore,
	showSecondaryApplyButton,
}) => {
	const isDesktop = useMediaQuery("(min-width: 768px)");
	const {
		heading = "Your profile does not meet the job requirements",
		// highlight_text = "You have low chances of getting this job",
		data = null,
	} = requirementsData;
	useEffect(() => {
		if (isCTACardOpen) {
			trackOnMixpanel(WEB_JOB_APPLICATION_INELIGIBLE_SCREEN_SHOWN, {
				"Job Requirements": jobRequirementsMPData,
				"Deal Breaker Score": dealBreakerScore,
				...commonTrackEventsJobProperties,
			});
		}
	}, [isCTACardOpen]);

	// In case of only location mismatch, we do not want to show primary CTA.
	const showPrimaryCTA = () => {
		let show = true;
		if (
			Array.isArray(requirementsData?.data?.requirements) &&
			requirementsData?.data?.requirements?.length > 0
		)
			requirementsData?.data?.requirements?.forEach((req) => {
				if (
					req?.title?.includes("Location") &&
					requirementsData?.data?.requirements?.length === 1
				) {
					show = false;
				}
			});
		return show;
	};
	return (
		<Portal>
			<Container isCTACardOpen={isCTACardOpen}>
				<RoundedCloseButtonContainer
					onClick={handleCloseClick}
					isCTACardOpen={isCTACardOpen}
				>
					<RoundedCloseIcon />
				</RoundedCloseButtonContainer>
				<div className={clsx("px-[24px] pt-[24px]", { hidden: !isDesktop })}>
					<div
						className="ml-auto w-max cursor-pointer"
						onClick={handleCloseClick}
					>
						<CrossIcon fill="#190A28" size="24" />
					</div>
				</div>
				<div className={clsx({ "px-[124px]": isDesktop })}>
					<div
						className={clsx("text-[20px] font-[700] leading-[28px]", {
							"text-center": isDesktop,
							"mx-[16px] mt-0": !isDesktop,
						})}
					>
						{heading}
					</div>
					<div className="mx-[16px] mt-[24px] max-w-[440px] rounded-lg border border-solid border-[#CB2F4B] p-[12px] md:mx-auto">
						<p className="m-0 text-sm leading-[20px] text-[#8C8594]">
							{data?.title}
						</p>
						<div className="mt-[12px] space-y-[12px]">
							{data?.requirements.map((reqObj) => (
								<div
									className={clsx(
										"mt-[12px] flex items-start gap-[8px]"
									)}
								>
									<div>
										<Image
											src={reqObj?.icon_link}
											alt="icon"
											width={16}
											height={16}
											layout="fixed"
										/>
									</div>
									<div>
										<div className="text-sm leading-[20px] text-[#190A28]">
											{reqObj?.title}
										</div>
										{reqObj?.sub_text && (
											<div className="text-sm leading-[20px] text-[#8C8594]">
												{reqObj?.sub_text}
											</div>
										)}
									</div>
								</div>
							))}
						</div>
					</div>
				</div>
				<hr className={clsx("mb-0 mt-[24px]", { hidden: !isDesktop })} />
				<div
					className={clsx(
						"flex flex-col gap-[16px] p-[16px] md:mx-auto md:max-w-[440px] md:p-0 md:py-[24px]",
						{
							"gap-[8px]": !isDesktop,
						}
					)}
				>
					{showSecondaryApplyButton && (
						<SecondaryBtn
							onClick={handleSecondaryBtnClick}
							disabled={handleSecondaryBtnDisabled}
						>
							Apply anyway
							{handleSecondaryBtnLoading && (
								<CircularProgress
									color="inherit"
									size={22}
									style={{ marginLeft: "10px" }}
								/>
							)}
						</SecondaryBtn>
					)}
					{showPrimaryCTA() && (
						<PrimaryBtn onClick={handlePrimaryBtnClick}>
							Explore best match jobs
						</PrimaryBtn>
					)}
				</div>
			</Container>
			<Overlay isCTACardOpen={isCTACardOpen} onClick={handleCloseClick} />
		</Portal>
	);
};

export default InEligibleJobNudge;

const Container = styled.div`
	position: fixed;
	bottom: 0;
	left: 0;
	width: 100%;
	height: fit-content;
	background-color: #fff;
	padding: 16px 0px;
	border-radius: 16px 16px 0px 0px;
	z-index: 30;
	transform: translateY(100%);
	transition: 0.4s ease;

	${({ isCTACardOpen }) =>
		isCTACardOpen &&
		css`
			transform: translateY(0%);
		`}

	${bp.md} {
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
		width: 690px;
		padding: 0;
		border-radius: 8px;
		transition: 0.4s ease;
		opacity: 0;
		z-index: -1;
		${({ isCTACardOpen }) =>
			isCTACardOpen &&
			css`
				z-index: 5;
				opacity: 1;
			`}
	}
`;

const Overlay = styled.div`
	position: fixed;
	top: 0;
	left: 0;
	bottom: 0;
	width: 100%;
	height: 100%;
	background: #000000;
	opacity: 0.7;
	z-index: 11;
	display: none;
	${bp.md} {
		z-index: 2;
	}
	${({ isCTACardOpen }) =>
		isCTACardOpen &&
		css`
			display: block;
		`}
`;

const PrimaryBtn = styled(Button)`
	background: ${getGlobalCSSVariants().primaryColor};
	border-radius: 4px;
	padding: 12px 32px;
	width: 100%;
	height: auto;
	font-weight: 600;
	font-size: 16px;
	line-height: 24px;
	text-align: center;
	color: #ffffff;
	display: flex;
	align-items: center;
	justify-content: center;
	${bp.md} {
		padding: 10px 16px;
	}
	:hover {
		background: ${getGlobalCSSVariants().primaryColor};
	}
`;

const SecondaryBtn = styled(PrimaryBtn)`
	background: #ffffff;
	border: 1px solid ${getGlobalCSSVariants().primaryColor};
	color: ${getGlobalCSSVariants().primaryColor};

	${bp.md} {
		margin: 0px;
		margin-right: 16px;
	}
	:hover {
		background: #ffffff;
		border: 1px solid ${getGlobalCSSVariants().primaryColor};
		color: ${getGlobalCSSVariants().primaryColor};
	}
`;

const RoundedCloseButtonContainer = styled.div`
	position: absolute;
	top: -48px;
	right: 16px;
	display: none;
	${({ isCTACardOpen }) =>
		isCTACardOpen &&
		css`
			display: block;
		`}
	${bp.md} {
		display: none;
	}
`;
